<template>
    
    <div class="mt-6">
        <div class="divide-y divide-gray-200">
            <ErrorSummary :response-status="responseStatus"/>
            
            <SkeletonCard  class="mt-4" v-if="isFetching" card-style="long" :num-of-cards=1 />

            <div v-else>
                <div class="mt-4">
                    <div class="relative flex items-start mb-4">
                        <div class="flex items-center h-5">
                            <input v-model="preferences.customer.unsubscribed"
                                   id="global"
                                   name="global"
                                   :checked="preferences.customer.unsubscribed"
                                   aria-describedby=""
                                   class="w-4 h-4 text-powder-600 border-2 border-gray-500 rounded cursor-pointer focus:ring-powder-500"
                                   type="checkbox">
                        </div>
                        <div class="ml-3 text-sm">
                            <label for="global" class="font-medium text-gray-700 cursor-pointer">Opt out of all communications</label>
                            <div class="text-clay-800 cursor-pointer">Fully unsubscribe from all topics, retaining only essential notifications.</div>
                        </div>
                    </div>
                </div>
                
                <hr class="my-4" />
                
                <div class="mt-4"
                     :class="preferences.customer.unsubscribed ? 'pointer-events-none opacity-30 cursor-not-allowed' : ''">
                    <div v-for="topic in preferences.customer.topics"
                         class="relative flex items-start mb-4">
                        <div class="flex items-center h-5">
                            <input v-model="topic.subscribed" 
                                   :id="topic.name"
                                   :name="topic.name"
                                   :checked="topic.subscribed"
                                   aria-describedby=""
                                   class="w-4 h-4 text-powder-600 border-2 border-gray-500 rounded cursor-pointer focus:ring-powder-500"
                                   type="checkbox">
                        </div>
                        <div class="ml-3 text-sm">
                            <label :for="topic.name" class="font-medium text-gray-700 cursor-pointer">{{ topic.name }}</label>
                            <div class="text-clay-800 cursor-pointer">{{ topic.description}}</div>
                        </div>
                    </div>
                </div>
                
                <div class="px-4 py-3 sm:px-6 md:w-1/4">
                    <SaButton @click.prevent="updateSubscriptionPreferences" :loading="isSubmitting" variant="primary">
                        Save Preferences
                    </SaButton>
                </div>
            </div>
        </div>
    </div>

    <NotificationSuccess :show="updateSuccessful" content="Your changes were successfully saved."
                         title="Successfully saved!"/>

</template>

<script lang="ts" setup>
import {computed, onMounted, Ref, ref} from "vue";
import {client} from '@/shared';
import {
    GetSubscriptionPreferences, GetSubscriptionPreferencesResponse
} from "@/dtos";
import NotificationSuccess from "@/main/components/NotificationSuccess.vue";
import ErrorSummary from "@/main/components/ErrorSummary.vue";
import SkeletonCard from "@/main/components/skeletons/SkeletonCard.vue";
import SaButton from "@/main/components/SaButton.vue";

onMounted(async () => {
    await getSubscriptionPreferences();
});
const preferences = ref({});

const isFetching = ref(true);
const getSubscriptionPreferences = async () => {
    await client.get<GetSubscriptionPreferencesResponse>(new GetSubscriptionPreferences())
        .then(response => {
            preferences.value = response.preferences;
            isFetching.value = false;
        });
}

const topics = computed(() => {
    let transformedTopics: any = {};
    
    preferences.value.customer.topics.forEach((t: any) => {
        transformedTopics[`topic_${t.id}`] = t.subscribed;
    });
    return transformedTopics;
});

const updateSuccessful: Ref<Boolean> = ref(false);
const responseStatus = ref(null);

const isSubmitting = ref(false);
const updateSubscriptionPreferences = async () => {
    isSubmitting.value = true;
    updateSuccessful.value = false;
    
    analytics.identify({
        cio_subscription_preferences: {
            topics: topics.value
        },
        unsubscribed: preferences.value.customer.unsubscribed
    });

    updateSuccessful.value = true;
    responseStatus.value = null;
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
    isSubmitting.value = false;
    
};

</script>